import { Skeleton, Divider, Tabs } from 'antd';
import TabPane from 'antd/es/tabs/TabPane';
import gql from 'graphql-tag';
import { useParams, useHistory } from 'react-router-dom';
import { useAuthedQuery } from 'utils/qlAuth';
import { UniverseMain } from './UniverseMain';
import { UniverseLeonardoFramesAutomation } from './UniverseLeonardoFramesAutomation';
import { UniverseRunwaymlVideoAutomation } from './UniverseRunwaymlVideoAutomation';

export interface OpenaiMessageInHistory {
  role: 'system' | 'assistant' | 'user' | 'function';
  content: string;
}

export const UniversePage = () => {
  const params = useParams<{ universeId: string; tabName: string }>();
  const tabName = params.tabName || 'main-form';
  const history = useHistory();

  const qUniverse = useAuthedQuery(
    gql`
      query UniverseController_getUniverseById($id: Int!) {
        UniverseController_getUniverseById(id: $id) {
          id
          name
          tags
          initMessage
          status
          type
          promtMutator
          promtTemplate
          extraVars
        }
      }
    `,
    {
      variables: { id: Number(params.universeId) },
    },
  );

  if (qUniverse.error) {
    return <div>error</div>;
  }
  const universe = qUniverse.data?.UniverseController_getUniverseById || {};
  if (qUniverse.loading || !universe) {
    return <Skeleton active />;
  }

  return (
    <>
      <h1>{universe.name}</h1>
      <Divider />
      <Tabs
        defaultActiveKey={tabName}
        onChange={(key: string) => {
          history.push(`/universe/${params.universeId}/${key}`);
        }}
      >
        <TabPane tab="Project" key="main">
          <UniverseMain qUniverse={qUniverse} universeId={Number(params.universeId)} />
        </TabPane>
        <TabPane tab="Leonardo" key="leonardo">
          <UniverseLeonardoFramesAutomation universeId={Number(params.universeId)} />
        </TabPane>
        <TabPane tab="Runwayml Video" key="runwayml-video">
          <UniverseRunwaymlVideoAutomation universeId={Number(params.universeId)} />
        </TabPane>
      </Tabs>
    </>
  );
};
